import React from "react";
import UberExternalDispatch from "../Uber/UberExternalDispatch";


const ExternalDispatchManager = (props) => {
    switch(props){
        case "Uber":
            return UberExternalDispatch;
        default:
            return () => <div>No template found or select a valid TNC provider.</div>
    }


}

export default ExternalDispatchManager;